<template>
  <LayoutPage title="Reporte de cliente">
    <!-- ================= FILTROS =================
         Sistema visual TelCo / Wee!. La lógica es la misma de siempre: mismos
         v-model, getData() y downloadExcel(). Los anchos se resuelven con
         flex-wrap y no con media queries: el área de contenido es más angosta que
         la ventana por el menú lateral. -->
    <div class="mx-5">
      <section class="rc-panel" aria-label="Filtros del reporte">
        <div class="rc-grid">
          <!-- v-menu envuelve al campo en su propio div: el ancho va en el v-menu -->
          <v-menu v-model="menu1" class="rc-campo--fecha" :close-on-content-click="true" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="rc-campo" :label="aprobados ? 'Aprobado desde' : 'Pagado desde'"
                prepend-inner-icon="mdi-calendar-start" readonly outlined dense hide-details color="#00B0EA"
                :value="formatDate(fechaDesde)" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fechaDesde" locale="es-ar" no-title scrollable
              :max="new Date().toISOString().substr(0, 10)" color="#00B0EA"></v-date-picker>
          </v-menu>

          <v-menu v-model="menu2" class="rc-campo--fecha" :close-on-content-click="true" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="rc-campo" :label="aprobados ? 'Aprobado hasta' : 'Pagado hasta'"
                prepend-inner-icon="mdi-calendar-end" readonly outlined dense hide-details color="#00B0EA"
                :value="formatDate(fechaHasta)" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fechaHasta" locale="es-ar" no-title scrollable :min="fechaDesde"
              :max="new Date().toISOString().substr(0, 10)" color="#00B0EA"></v-date-picker>
          </v-menu>

          <v-select v-model="filtroCanal" class="rc-campo rc-campo--canal" :items="canales" label="Canal de pago"
            placeholder="Todos" persistent-placeholder prepend-inner-icon="mdi-credit-card-outline" multiple
            outlined dense hide-details clearable color="#00B0EA" item-color="#00B0EA">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0" class="rc-sel-chip">{{ item.text }}</span>
              <span v-if="index === 1" class="rc-sel-mas">+{{ filtroCanal.length - 1 }}</span>
            </template>
          </v-select>

          <!-- Monto: opcional, busca por importe a pagar o por importe pagado.
               Sin hint: el estilo global pinta de rojo los mensajes de los campos. -->
          <v-text-field v-model="filtroMonto" class="rc-campo rc-campo--monto" label="Monto" prefix="$"
            prepend-inner-icon="mdi-cash" type="number" min="0" step="0.01" outlined dense hide-details clearable
            color="#00B0EA" title="Opcional. Busca por importe a pagar o por importe pagado"
            @keyup.enter="getData(true)"></v-text-field>

          <v-btn class="rc-cta" depressed rounded height="40" :loading="cargandoTabla" :disabled="isLoading"
            @click="getData()">
            <v-icon left size="18">mdi-magnify</v-icon>
            Solicitar
          </v-btn>
        </div>

        <div class="rc-opciones" role="group" aria-label="Opciones del reporte">
          <button type="button" :class="['rc-toggle', { 'rc-toggle--on': allClients }]"
            :aria-pressed="String(allClients)" @click="allClients = !allClients">
            <v-icon size="16" class="mr-1" :color="allClients ? '#00B0EA' : '#6b7280'">
              {{ allClients ? "mdi-check-circle" : "mdi-account-group-outline" }}
            </v-icon>
            Operaciones de todos los clientes
          </button>
          <button type="button" :class="['rc-toggle', { 'rc-toggle--on': aprobados }]"
            :aria-pressed="String(aprobados)" title="Filtra el período por fecha de aprobación"
            @click="aprobados = !aprobados">
            <v-icon size="16" class="mr-1" :color="aprobados ? '#00B0EA' : '#6b7280'">
              {{ aprobados ? "mdi-check-circle" : "mdi-check-decagram-outline" }}
            </v-icon>
            Operaciones aprobadas
          </button>
        </div>
      </section>
    </div>

    <!-- Herramientas de la tabla: vista a la izquierda; total y Excel a la
         derecha. El Excel siempre trae las 50 columnas. -->
    <div class="rc-toolbar mx-5">
      <div class="rc-toolbar-izq">
        <div class="rc-vistas" role="tablist" aria-label="Vista de la tabla">
          <button v-for="v in vistas" :key="v.key" type="button" role="tab"
            :class="['rc-vista', { 'rc-vista--on': vista === v.key }]" :aria-selected="String(vista === v.key)"
            @click="cambiarVista(v.key)">
            <v-icon size="16" class="mr-1" :color="vista === v.key ? '#00B0EA' : '#6b7280'">{{ v.icono }}</v-icon>
            {{ v.text }}
          </button>
        </div>

      </div>

      <div class="rc-toolbar-der">
        <div class="rc-kpi" aria-label="Total rendido">
          <div class="rc-kpi-icon">
            <v-icon color="#009238" size="20">mdi-bank-transfer-in</v-icon>
          </div>
          <div class="rc-kpi-content">
            <div class="rc-kpi-label">Total rendido</div>
            <div v-if="cargandoTabla" class="rc-sk rc-sk--kpi"></div>
            <div v-else class="rc-kpi-value">{{ formatImport(totalRendido) }}</div>
          </div>
        </div>

        <v-btn class="rc-excel" outlined rounded height="40" color="#009238" :disabled="isLoading"
          :loading="generandoExcel" @click="downloadExcel()">
          <v-icon left size="18">mdi-microsoft-excel</v-icon>
          Descargar Excel
        </v-btn>
      </div>
    </div>

    <div class="rc-tabla mx-5">
      <v-data-table :headers="currentColumns" :items="data" item-key="_fila"
        no-data-text="Sin pagos para los filtros elegidos" disable-sort hide-default-footer disable-pagination
        mobile-breakpoint="0" :class="['rc-dt', { 'rc-dt--resumen': vista === 'resumen' }]"
        @click:row="abrirDetalle">

      <!-- Skeleton de carga (reemplaza a la barra de Vuetify): filas con brillo
           cyan, una celda por columna de la vista actual. -->
      <template v-if="cargandoTabla" v-slot:body>
        <tbody class="rc-sk-body" aria-busy="true" aria-label="Cargando pagos">
          <tr v-for="fila in filasSkeleton" :key="'sk' + fila">
            <td v-for="(h, i) in currentColumns" :key="h.value" :class="{ 'text-end': h.align === 'end' }">
              <template v-if="h.value === 'detalle'">
                <span class="rc-sk rc-sk--punto"></span>
              </template>
              <template v-else>
                <span class="rc-sk" :style="{ width: anchoSkeleton(fila, i) }"></span>
                <span v-if="vista === 'resumen' && i < 4" class="rc-sk rc-sk--sec"
                  :style="{ width: anchoSkeleton(fila + 3, i) }"></span>
              </template>
            </td>
          </tr>
        </tbody>
      </template>

      <!-- ===== Vista resumen: celdas compuestas ===== -->
      <template v-if="vista === 'resumen'" v-slot:item.fecha_pago="{ item }">
        <div class="rc-c-principal">{{ formatearCampo("fecha_pago", item.fecha_pago) }}</div>
        <div v-if="tieneFecha(item.fecha_rendicion)" class="rc-c-sec">
          Rendido {{ formatearCampo("fecha_rendicion", item.fecha_rendicion) }}
        </div>
      </template>

      <template v-if="vista === 'resumen'" v-slot:item.pago_id="{ item }">
        <div class="rc-c-principal rc-num">#{{ item.pago_id }}</div>
        <div v-if="item.referencia_externa" class="rc-c-sec rc-c-trunc" :title="item.referencia_externa">
          Ref. {{ item.referencia_externa }}
        </div>
      </template>

      <template v-if="vista === 'resumen'" v-slot:item.cliente="{ item }">
        <div class="rc-c-principal rc-c-trunc" :title="item.cliente">{{ item.cliente }}</div>
        <div class="rc-c-sec rc-c-trunc" :title="item.cuenta">{{ item.cuenta }}</div>
      </template>

      <template v-if="vista === 'resumen'" v-slot:item.medio_pago="{ item }">
        <span class="rc-medio">{{ item.medio_pago || "—" }}</span>
        <div v-if="item.cuotas > 1" class="rc-c-sec">{{ item.cuotas }} cuotas</div>
      </template>

      <template v-if="vista === 'resumen'" v-slot:item.importe_pagado="{ item }">
        <div class="rc-c-principal rc-num">{{ formatearCampo("importe_pagado", item.importe_pagado) }}</div>
        <div v-if="item.importe_a_pagar && item.importe_a_pagar !== item.importe_pagado" class="rc-c-sec rc-num"
          title="Importe a pagar">
          a pagar {{ formatearCampo("importe_a_pagar", item.importe_a_pagar) }}
        </div>
      </template>

      <!-- Prisma no informa el neto por operación: se muestra el neto interno
           (calculado) con una marca. -->
      <template v-if="vista === 'resumen'" v-slot:item.importe_neto_cobrado="{ item }">
        <template v-if="item.sin_neto_operador">
          <div class="rc-c-principal rc-num">{{ valorCampo("importe_neto_cobrado_interno", item) }}</div>
          <div class="rc-c-sec" title="Prisma no informa el neto por operación: pagado − CFT − IVA CFT − arancel − IVA arancel">
            {{ item.arancel_pendiente ? "pendiente de Prisma" : "calculado" }}
          </div>
        </template>
        <div v-else class="rc-c-principal rc-num">
          {{ formatearCampo("importe_neto_cobrado", item.importe_neto_cobrado) }}
        </div>
      </template>

      <template v-if="vista === 'resumen'" v-slot:item.importe_rendido="{ item }">
        <div class="rc-c-principal rc-num rc-rendido">
          {{ formatearCampo("importe_rendido", item.importe_rendido) }}
        </div>
      </template>

      <template v-slot:item.detalle>
        <v-icon size="20" color="#9ca3af">mdi-chevron-right</v-icon>
      </template>

      <!-- Estado: chip con el semáforo de Wee! en todas las vistas -->
      <template v-slot:item.estado="{ item }">
        <span class="rc-estado" :style="{ background: tonoEstado(item.estado).bg, color: tonoEstado(item.estado).color }">
          <v-icon size="13" :color="tonoEstado(item.estado).color" class="mr-1">
            {{ tonoEstado(item.estado).icono }}
          </v-icon>
          {{ labelEstado(item.estado) }}
        </span>
      </template>

      <!-- ===== Vistas por tema: formato según el tipo de cada campo ===== -->
      <template v-for="h in columnasConFormato" v-slot:[`item.${h.value}`]="{ item }">
        <span :key="h.value" :class="{ 'rc-num': esNumerico(h.value) }"
          :title="campoNoAplica(h.value, item) ? (item.arancel_pendiente ? 'Pendiente: Prisma todavía no informó la operación' : 'El operador no informa el neto por operación') : undefined">
          {{ valorCampo(h.value, item) }}
        </span>
      </template>

      <template v-slot:footer>
        <div class="rc-footer">
          <div class="rc-footer-info">
            <template v-if="cargandoTabla">
              <span class="rc-sk rc-sk--info"></span>
            </template>
            <template v-else-if="pagination.total > 0">
              Mostrando <strong>{{ rangoDesde }}–{{ rangoHasta }}</strong> de
              <strong>{{ pagination.total.toLocaleString("es-AR") }}</strong> pagos
            </template>
          </div>

          <v-pagination v-model="pagination.number" class="rc-pag" :length="pagination.lastPage || 1"
            :total-visible="7" color="#00B0EA" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
            :disabled="isLoading" @input="getData()"></v-pagination>

          <div class="rc-por-pagina" role="group" aria-label="Pagos por página">
            <span class="rc-por-pagina-label">Por página</span>
            <div class="rc-seg">
              <button v-for="n in rowsPerPageArray" :key="n" type="button"
                :class="['rc-seg-btn', { 'rc-seg-btn--on': pagination.size === n }]"
                :aria-pressed="String(pagination.size === n)" :disabled="isLoading" @click="cambiarTamanio(n)">
                {{ n }}
              </button>
            </div>
          </div>
        </div>
      </template>
      </v-data-table>
    </div>

    <DetallePagoDrawer v-model="detalleAbierto" :pago="pagoDetalle" />

    <!-- <loader object="#4caf50" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793"
      opacity="40" disableScrolling="false" name="box" v-show="isLoading"></loader> -->
  </LayoutPage>
</template>

<script>
// import LayoutPage from "@/components/LayoutPage.vue";
import LayoutPage from "../../../components/LayoutPage.vue";
import moment from "moment";
import formatDate from "../../../utils/formatDate";
import formatImport, { formatImportFloat } from "../../../utils/formatImport";
import { headers } from "./headerReporte";
import {
  VISTAS,
  formatearCampo,
  valorCampo,
  campoNoAplica,
  esNumerico,
  tonoEstado,
  labelEstado,
} from "./reporteFormato";
import DetallePagoDrawer from "../../../components/Reporte/DetallePagoDrawer.vue";

// Clave de localStorage con la última vista elegida (conveniencia por usuario).
const VISTA_STORAGE = "reporteCliente.vista";
const vistaGuardada = () => {
  try {
    const v = window.localStorage.getItem(VISTA_STORAGE);
    return VISTAS.some((x) => x.key === v) ? v : "resumen";
  } catch (e) {
    return "resumen";
  }
};
import reportesService from "../../../services/reportes";
import { mapGetters } from "vuex";
import { descargarExcelReporteClientes } from "./excelReporteClientes";

export default {
  name: "ReporteCliente",
  components: { LayoutPage, DetallePagoDrawer },
  data() {
    return {
      fechaDesde: moment()
        .subtract(1, "days")
        .subtract(1, "months")
        .format("YYYY-MM-DD"),

      fechaHasta: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),

      menu1: false,
      menu2: false,
      filtroCanal: null,
      filtroMonto: null,
      canales: [
        { value: 1, text: "CREDITO" },
        { value: 2, text: "DEBITO" },
        { value: 3, text: "OFFLINE" },
        { value: 4, text: "DEBIN" },
        { value: 5, text: "QR" },
        { value: 6, text: "MULTIPAGOS" },
        { value: 7, text: "QR-FACTURA" },
        { value: 8, text: "QR-ESTATICO" },
        { value: 9, text: "PREPAGA" },
      ],

      data: [],
      excelData: [],
      excelTotalRendido: 0,
      vistas: VISTAS,
      vista: vistaGuardada(),
      detalleAbierto: false,
      pagoDetalle: null,

      totalRendido: 0,

      allClients: false,
      aprobados: false,
      isLoading: false,

      pagination: {
        number: 1,
        size: 10,
        lastPage: 0,
        total: 0,
      },
      // cargandoTabla muestra el skeleton; el Excel usa generandoExcel para no
      // reemplazar la tabla mientras arma el archivo.
      cargandoTabla: false,
      generandoExcel: false,

      rowsPerPageArray: [10, 30, 50],

      headers,
      formatDate,
      formatImport,
      formatImportFloat,
      formatearCampo,
      valorCampo,
      campoNoAplica,
      esNumerico,
      tonoEstado,
      labelEstado,
    };
  },
  computed: {
    ...mapGetters(["getCurrentClientId", "getCurrentClientName", "getCurrentClientEmail"]),

    // Filas del skeleton: las de la página, con un tope para no estirar la vista.
    filasSkeleton() {
      return Math.min(this.pagination.size || 10, 12);
    },
    rangoDesde() {
      return (this.pagination.number - 1) * this.pagination.size + 1;
    },
    rangoHasta() {
      return Math.min(this.pagination.number * this.pagination.size, this.pagination.total);
    },
    vistaActual() {
      return VISTAS.find((v) => v.key === this.vista) || VISTAS[0];
    },
    currentColumns() {
      return this.vistaActual.headers;
    },
    // Columnas que se muestran con el formato genérico de su tipo. En el
    // resumen las celdas son compuestas y estado tiene su propio chip.
    columnasConFormato() {
      if (this.vista === "resumen") return [];
      return this.vistaActual.headers.filter((h) => h.value !== "estado");
    },

    daysDifference() {
      return moment(this.fechaHasta).diff(moment(this.fechaDesde), "days");
    },
  },
  watch: {
    // realiza el fetch datos cuando se cambia de usuario
    getCurrentClientId() {
      this.getData(true);
    },
  },

  mounted() {
    this.$nextTick(() => this.getData());
  },

  methods: {
    async getData(resetNumber = false, excelData = false) {
      if (resetNumber) this.pagination.number = 1;

      if (this.daysDifference > 31) {
        this.$toastr.e("El rango de fechas no puede ser mayor a 31 días");
        return;
      }


      let params = {
        ClienteId: this.getCurrentClientId,
        Number: this.pagination.number,
        Size: this.pagination.size,
      };

      // Usar nombres de parámetro distintos si se filtró por aprobados
      if (this.aprobados) {
        params.FechaAprobadoDesde = this.fechaDesde + "T00:00:00-03:00";
        params.FechaAprobadoHasta = this.fechaHasta + "T23:59:59-03:00";
      } else {
        params.FechaInicio = this.fechaDesde + "T00:00:00-03:00";
        params.FechaFin = this.fechaHasta + "T23:59:59-03:00";
      }

      if (this.filtroCanal && this.filtroCanal.length > 0) {
        params = { ...params, Channels: this.filtroCanal.toString() };
      }

      // Monto en pesos: el backend lo pasa a centavos y lo compara con el importe a
      // pagar y con el importe pagado.
      const monto = Number(String(this.filtroMonto ?? "").replace(",", "."));
      if (monto > 0) params.Monto = monto;

      if (excelData) {
        delete params.Number;
        delete params.Size;
      }

      if (this.allClients) delete params.ClienteId;
      try {
        this.isLoading = true;
        if (excelData) this.generandoExcel = true;
        else this.cargandoTabla = true;
        const { data } = await reportesService.reporteClientes(params);

        if (excelData) {
          this.excelTotalRendido = data?.total_rendido || 0;
          return (this.excelData = data?.pagos || []);
        }

        // Clave única por fila: un pago revertido viene dos veces con el mismo
        // pago_id (la fila AUTORIZADO y la fila REVERTIDO).
        this.data = (data?.pagos || []).map((p, i) => ({ ...p, _fila: i }));
        this.totalRendido = data?.total_rendido || 0;
        this.pagination.lastPage = data?.meta?.page?.lastPage;
        // Sin paginación el backend no arma meta: el total es lo que vino.
        this.pagination.total = data?.meta?.page?.total || this.data.length;
      } catch (error) {
        const mensaje = (error?.response?.data?.message || "").toLowerCase();

        if (mensaje.includes("no se encontraron pagos")) {
          // Sin resultados: se limpia la tabla para no dejar los del filtro anterior.
          if (!excelData) {
            this.data = [];
            this.totalRendido = 0;
            this.pagination.lastPage = 0;
            this.pagination.total = 0;
          }
          this.$toastr.w("No se encontraron pagos");
        } else {
          this.$toastr.e("Error al obtener pagos");
        }
        // console.error(error);
      } finally {
        this.isLoading = false;
        this.cargandoTabla = false;
        this.generandoExcel = false;
      }
    },

    cambiarTamanio(n) {
      if (this.pagination.size === n) return;
      this.pagination.size = n;
      this.getData(true);
    },

    // Anchos variados para que el skeleton se lea como contenido y no como
    // una grilla de barras iguales. Determinístico: no cambia entre renders.
    anchoSkeleton(fila, columna) {
      const anchos = [62, 78, 48, 70, 85, 55, 66, 74];
      return anchos[(fila * 3 + columna * 5) % anchos.length] + "%";
    },

    cambiarVista(key) {
      this.vista = key;
      try {
        window.localStorage.setItem(VISTA_STORAGE, key);
      } catch (e) {
        // sin almacenamiento: la vista vuelve al resumen en la próxima visita
      }
    },

    abrirDetalle(item) {
      this.pagoDetalle = item;
      this.detalleAbierto = true;
    },

    tieneFecha(valor) {
      return !!valor && valor !== 0 && valor !== "-";
    },

    // Excel con el sistema visual TelCo (ver excelReporteClientes.js): mismas
    // filas y columnas que la pantalla, con encabezado, importes numéricos,
    // filtros y totales.
    downloadExcel() {
      if (this.data.length === 0) {
        this.$toastr.e("No hay datos para exportar");
        return;
      }
      this.excelData = [];
      this.getData(false, true)
        .then(async () => {
          if (this.excelData.length === 0) return;
          const canales = (this.filtroCanal || [])
            .map((v) => (this.canales.find((c) => c.value === v) || {}).text)
            .filter(Boolean)
            .join(", ");
          const monto = Number(String(this.filtroMonto ?? "").replace(",", "."));
          await descargarExcelReporteClientes({
            pagos: this.excelData,
            totalRendido: this.excelTotalRendido,
            filtros: {
              fechaDesde: this.fechaDesde,
              fechaHasta: this.fechaHasta,
              aprobados: this.aprobados,
              cliente: this.allClients ? "Todos los clientes" : this.getCurrentClientName,
              canales: canales || "Todos",
              monto: monto > 0 ? formatImportFloat(monto) : "Sin filtro",
              usuario: this.getCurrentClientEmail,
              generado: new Date(),
            },
          });
          this.$toastr.s("Excel generado con éxito");
        })
        .catch(() => this.$toastr.e("Error al generar excel"));
    },
  },
};
</script>

<style scoped>
/* ─── Filtros del reporte (sistema visual TelCo / Wee!) ─────────────── */
.rc-panel {
  position: relative;
  overflow: hidden;
  min-width: 0;
  margin-top: 8px;
  background: #ffffff;
  border: 1px solid #eef0f4;
  border-radius: 16px;
  padding: 20px 20px 16px;
  box-shadow: 0 6px 24px rgba(0, 176, 234, 0.08);
}
/* Línea de acento con el gradiente principal TelCo */
.rc-panel::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 4px;
  background: linear-gradient(90deg, #00b0ea 0%, #ccd400 100%);
}


/* Campos: se acomodan solos al ancho disponible; si no entran, Solicitar
   baja a la línea siguiente alineado a la derecha en vez de cortarse. */
.rc-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.rc-campo {
  min-width: 0;
}
.rc-campo--fecha {
  flex: 1 1 150px;
  min-width: 0;
}
.rc-campo--canal {
  flex: 1.4 1 190px;
}
.rc-campo--monto {
  flex: 1 1 150px;
}
.rc-cta {
  flex: 0 0 auto;
  margin-left: auto;
}

.rc-campo ::v-deep .v-input__slot {
  border-radius: 10px !important;
  background: #ffffff;
}
.rc-campo ::v-deep fieldset {
  border-color: #d7dde3;
}
.rc-campo ::v-deep .v-input__prepend-inner .v-icon {
  color: #00b0ea;
}

.rc-sel-chip {
  display: inline-flex;
  align-items: center;
  background: #e6f7fd;
  border: 1px solid #b8e8f8;
  color: #0087b5;
  border-radius: 999px;
  padding: 1px 10px;
  font-size: 12px;
  font-weight: 600;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rc-sel-mas {
  margin-left: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #00b0ea;
}

/* CTA con gradiente secundario TelCo (verde oscuro → cyan): el principal
   termina en verde lima y el texto blanco pierde contraste. */
.rc-cta.v-btn {
  background: linear-gradient(135deg, #009238 0%, #00b0ea 100%) !important;
  color: #ffffff !important;
  font-family: "Plus Jakarta Sans", Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  padding: 0 24px !important;
  box-shadow: 0 6px 18px rgba(0, 176, 234, 0.3) !important;
}
.rc-cta.v-btn:hover {
  box-shadow: 0 8px 24px rgba(0, 176, 234, 0.4) !important;
}

.rc-opciones {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e6eaee;
}
.rc-toggle {
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  border: 1px solid #d7dde3;
  background: #ffffff;
  color: #4b5563;
  border-radius: 999px;
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.rc-toggle:hover {
  border-color: #b8e8f8;
  color: #00b0ea;
}
.rc-toggle:focus-visible {
  outline: 2px solid #00b0ea;
  outline-offset: 2px;
}
.rc-toggle--on {
  background: #e6f7fd;
  border-color: #00b0ea;
  color: #0087b5;
  font-weight: 700;
}

/* Herramientas de la tabla */
.rc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 16px 0 12px;
}
.rc-toolbar-der {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-left: auto;
}

/* KPI compacto: total rendido */
.rc-kpi {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 18px 8px 8px;
  border-radius: 999px;
  border: 1px solid rgba(0, 146, 56, 0.18);
  background: linear-gradient(135deg, #e6f4eb 0%, #f8fbd9 100%);
  box-shadow: 0 4px 16px rgba(204, 212, 0, 0.14);
}
.rc-kpi-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rc-kpi-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #009238;
  white-space: nowrap;
}
.rc-kpi-value {
  font-family: "Plus Jakarta Sans", Montserrat, sans-serif;
  font-size: 19px;
  font-weight: 700;
  color: #2f2f2f;
  line-height: 1.15;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rc-toolbar-izq {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
}

/* Selector de vista: control segmentado (mismo patrón que Bloqueados) */
.rc-vistas {
  display: inline-flex;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid #b8e8f8;
  border-radius: 999px;
  background: #ffffff;
  padding: 3px;
  gap: 2px;
}
.rc-vista {
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  border: 0;
  background: transparent;
  border-radius: 999px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  padding: 6px 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;
}
.rc-vista:hover {
  color: #00b0ea;
}
.rc-vista:focus-visible {
  outline: 2px solid #00b0ea;
  outline-offset: 1px;
}
.rc-vista--on {
  background: #e6f7fd;
  color: #0087b5;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 176, 234, 0.15);
}

/* ─── Tabla ────────────────────────────────────────────────────────── */
.rc-tabla {
  background: #ffffff;
  border: 1px solid #eef0f4;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0, 176, 234, 0.06);
  margin-bottom: 24px;
}
.rc-dt ::v-deep table thead th {
  background: #f5f7f9 !important;
  color: #6b7280 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: 1px solid #eef0f4 !important;
}
.rc-dt ::v-deep table tbody td {
  font-size: 13px !important;
  color: #2f2f2f;
  border-bottom: 1px solid #f1f3f6 !important;
  white-space: nowrap;
}
.rc-dt ::v-deep table tbody tr {
  cursor: pointer;
  transition: background 0.12s;
}
.rc-dt ::v-deep table tbody tr:hover {
  background: #f3fbfe !important;
}
.rc-dt--resumen ::v-deep table tbody td {
  height: 60px !important;
}

.rc-c-principal {
  font-weight: 600;
  color: #2f2f2f;
  line-height: 1.3;
}
.rc-c-sec {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
}
.rc-c-trunc {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rc-num {
  font-variant-numeric: tabular-nums;
}
.rc-rendido {
  color: #009238;
}
.rc-medio {
  display: inline-flex;
  align-items: center;
  background: #f5f7f9;
  border: 1px solid #eef0f4;
  border-radius: 6px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}
.rc-estado {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  line-height: 1.2;
  white-space: nowrap;
}

/* ─── Skeleton de carga ───────────────────────────────────────────── */
.rc-sk {
  display: block;
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, #eef6fa 0%, #d9f1fb 40%, #eef6fa 80%);
  background-size: 200% 100%;
  animation: rc-brillo 1.3s ease-in-out infinite;
}
.text-end .rc-sk {
  margin-left: auto;
}
.rc-sk--sec {
  height: 9px;
  margin-top: 7px;
  opacity: 0.7;
}
.rc-sk--punto {
  width: 14px;
  height: 14px;
  margin-left: auto;
}
.rc-sk--kpi {
  width: 120px;
  height: 18px;
  margin-top: 3px;
}
.rc-sk--info {
  width: 170px;
  height: 11px;
}
.rc-sk-body tr:hover {
  background: transparent !important;
  cursor: default;
}
@keyframes rc-brillo {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .rc-sk {
    animation: none;
  }
}

/* ─── Paginación ───────────────────────────────────────────────────── */
.rc-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #eef0f4;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcfe 100%);
}
@media (max-width: 900px) {
  .rc-footer {
    grid-template-columns: 1fr;
    justify-items: center;
  }
}
.rc-footer-info {
  font-size: 13px;
  color: #6b7280;
}
.rc-footer-info strong {
  color: #2f2f2f;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.rc-pag ::v-deep .v-pagination {
  flex-wrap: wrap;
}
.rc-pag ::v-deep .v-pagination__item,
.rc-pag ::v-deep .v-pagination__navigation {
  box-shadow: none !important;
  border-radius: 999px;
  min-width: 34px;
  height: 34px;
  margin: 2px;
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;
}
.rc-pag ::v-deep .v-pagination__item:not(.v-pagination__item--active),
.rc-pag ::v-deep .v-pagination__navigation {
  background: transparent !important;
  color: #4b5563;
}
.rc-pag ::v-deep .v-pagination__item:not(.v-pagination__item--active):hover,
.rc-pag ::v-deep .v-pagination__navigation:not(.v-pagination__navigation--disabled):hover {
  background: #e6f7fd !important;
  color: #0087b5;
}
.rc-pag ::v-deep .v-pagination__navigation .v-icon {
  color: #00b0ea;
}
.rc-pag ::v-deep .v-pagination__item--active {
  background: #00b0ea !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(0, 176, 234, 0.3) !important;
}
.rc-pag ::v-deep .v-pagination__more {
  color: #9ca3af;
}

.rc-por-pagina {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.rc-por-pagina-label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.rc-seg {
  display: inline-flex;
  border: 1px solid #b8e8f8;
  border-radius: 999px;
  background: #ffffff;
  padding: 2px;
  gap: 2px;
}
.rc-seg-btn {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  background: transparent;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  min-width: 36px;
  padding: 4px 10px;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
  transition: background 0.15s, color 0.15s;
}
.rc-seg-btn:hover:not(:disabled) {
  color: #00b0ea;
}
.rc-seg-btn:focus-visible {
  outline: 2px solid #00b0ea;
  outline-offset: 1px;
}
.rc-seg-btn:disabled {
  cursor: default;
  opacity: 0.6;
}
.rc-seg-btn--on {
  background: #e6f7fd;
  color: #0087b5;
  font-weight: 700;
}

/* ─── Barras de desplazamiento en cyan TelCo ───────────────────────── */
.rc-dt ::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #00b0ea #e6f7fd;
}
.rc-dt ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.rc-dt ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e6f7fd;
  border-radius: 999px;
}
.rc-dt ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #00b0ea 0%, #4fc9f0 100%);
  border-radius: 999px;
  border: 2px solid #e6f7fd;
}
.rc-dt ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #0087b5;
}

.rc-excel.v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.3px;
  border-color: #009238;
}
</style>
